var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.833 4.5a1 1 0 011-1h12.5a1 1 0 011 1v10.833a1 1 0 01-1 1h-12.5a1 1 0 01-1-1V4.5zm2 1v8.833h10.5V5.5h-10.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.333 8.667a1 1 0 011-1h3.334a1 1 0 01.707.293l2.5 2.5a1 1 0 01.293.707v4.166a1 1 0 01-1 1h-5.834a1 1 0 01-1-1V8.667zm2 1v4.666h3.834v-2.752l-1.915-1.914h-1.919zM6.583 16.333a1.083 1.083 0 100 2.167 1.083 1.083 0 000-2.167zM3.5 17.417a3.083 3.083 0 116.167 0 3.083 3.083 0 01-6.167 0z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.417 16.333a1.083 1.083 0 100 2.167 1.083 1.083 0 000-2.167zm-3.084 1.084a3.083 3.083 0 116.167 0 3.083 3.083 0 01-6.167 0z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.eeacc29ab7d03829aa6792c2e893394a.svg";
export { ForwardRef as ReactComponent };